import type { FaireProductEntity } from "../../entity_types/product";

export const p_htxkag3mk8: FaireProductEntity = {
  token: "p_htxkag3mk8",
  type: "product",
  name: "watercolor paint set 18 colors with brush",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/1350752bfac0e3a6991197512ace3a86b7ecb801c275c24e42c42e7cba2df87f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/38b24432ce770228cc02dea568c3cf064ae6530626d629c99155884d27bdc49f.jpeg",
    "https://cdn.faire.com/fastly/8010141e638f0a17c6fc526c3b34f14067c6e2ca83c27200e73c592fb2d8d070.jpeg",
    "https://cdn.faire.com/fastly/bea28c308d8c7b8ad307450d66078a02ee4405c551bd80a9f69c2e6a283f943c.jpeg",
    "https://cdn.faire.com/fastly/f09fa98e0c9a9dab307a4456c6c345a27c4b5b4a5be48437a6f8c5a9ed11a202.jpeg",
    "https://cdn.faire.com/fastly/d48f4498ba933fe4354e533e9ec2896d540ea2109bb36448da0ea1fc1033dbdf.jpeg",
    "https://cdn.faire.com/fastly/3ee6611c35c747b08abf04e5acbf4bb5717d67509bf011cd1d50fa50ebe7eef4.jpeg",
    "https://cdn.faire.com/fastly/0c02eee2d2f2530a392f67f3cc0940ddf380fd6d3970ff895d81a4fa490dc36d.jpeg",
  ],
  priceDollars: 11,
  description:
    "Everything you need to start painting, gathered in one compact tin. This set was designed to pair beautifully with the Emily Lex Studio watercolor workbooks and paintable notecards. The 18 colors are beautiful straight from the palette, but also work wonderfully to mix your own colors.\n\nThe fold-open tin holds your paints, mixing trays, and a petite size 6 round brush. Lightweight and travel-ready, it tucks easily into a bag so you can paint wherever the mood strikes.\n\nDetails: \n- 18 watercolors in a range of hues for easy mixing\n- fold-open tin with built-in mixing trays and color swatching card\n- petite size 6 round brush included\n- non-toxic · meets ASTM D-4236 standards\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:06.942Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
